import Cookies from 'js-cookie';

if (apiUrl && Object.keys(loginEntryPoints).length) {
	const redirectByRegion = (region = '') => {
		if (region && region in loginEntryPoints) {
			location.assign(loginEntryPoints[region]);
		} else {
			location.assign(loginEntryPoints[Object.keys(loginEntryPoints)[0]]);
		}
	};

	try {
		const cookieLoginURL = Cookies.get('MP_LOGIN_URL');
		if (cookieLoginURL) {
			location.assign(cookieLoginURL);
		} else {
			const localStorageKey = 'visitorRegion';
			const region = localStorage.getItem(localStorageKey);
			if (!region) {
				fetch(apiUrl + '/api/public/v1/region')
					.then((res) => res.json())
					.then((data) => {
						const region = data.region.toLowerCase();
						localStorage.setItem(localStorageKey, region);
						redirectByRegion(region);
					});
			} else {
				redirectByRegion(region);
			}
		}
	} catch {
		redirectByRegion();
	}
}
